import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL + '/v1/'

const axiosConfig = {
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
    },
}

const submitContact = (payload) => {
    return axios.post(API_URL + 'public/contact', payload, axiosConfig)
}

const contactService = {
    submitContact,
}

export default contactService
